/**
 * Pharmacist Presence Tracking Configuration
 * Centralized configuration for WebSocket-based presence tracking
 */

const getPharmacistPresenceConfig = () => {
  return {
    // Enable/disable pharmacist presence tracking
    enabled: process.env.REACT_APP_PRESENCE_TRACKING_ENABLED === 'true',
    
    // WebSocket URL for presence tracking
    websocketUrl: process.env.REACT_APP_PRESENCE_WS_URL || 'ws://localhost:3001',
    
    // Heartbeat interval in milliseconds (30 seconds)
    heartbeatInterval: parseInt(process.env.REACT_APP_PRESENCE_HEARTBEAT_INTERVAL || '30000', 10),
    
    // Auto-reconnect settings
    autoReconnect: process.env.REACT_APP_PRESENCE_AUTO_RECONNECT !== 'false', // Default: true
    reconnectDelay: parseInt(process.env.REACT_APP_PRESENCE_RECONNECT_DELAY || '5000', 10), // 5 seconds
    
    // Debug logging
    debugLogging: process.env.REACT_APP_PRESENCE_DEBUG === 'true',
  };
};

export default getPharmacistPresenceConfig;




// WEBPACK FOOTER //
// ./src/config/pharmacist-presence-config.js